/**
 * Maps backend `platform_modules.module_code` to registered React components.
 * Used when the DB catalog row has no `component` value (defaults were GenericSchoolModule).
 */
export const PLATFORM_MODULE_COMPONENTS: Record<string, string> = {
  dashboard: 'Dashboard',
  students: 'Students',
  enrollment: 'SessionPromotion',
  teachers: 'Staff',
  teacher_portal: 'TeacherPortal',
  portal: 'StudentPortal',
  class_attendance: 'ClassAttendance',
  staff: 'Staff',
  staff_leave: 'StaffLeave',
  school: 'School',
  courses: 'Courses',
  schedule: 'Schedule',
  exams: 'Grades',
  assignments: 'Assignments',
  library: 'Library',
  report_card: 'ReportCards',
  certificate: 'Certificates',
  fees: 'Fees',
  transport: 'Transport',
  hostel: 'Hostel',
  permissions: 'Permissions',
  communication: 'Communication',
  announcements: 'Announcements',
  security: 'Security',
  pickup_pass: 'IssuePickupPass',
  pickup_issue: 'IssuePickupPass',
  academic_planning: 'Holidays',
  ai_questions: 'AiQuestions',
  procurement: 'Procurement',
  inventory: 'Inventory',
  canteen: 'Canteen',
  expense: 'Expenses',
  admission: 'Admissions',
  website: 'Website',
  settings: 'Settings',
  parent_consent: 'ParentConsentVault',
  board_readiness: 'BoardReadiness',
  risk_insights: 'RiskInsights',
  teaching_analytics: 'TeachingAnalytics',
};

/** Resolve React component name for a platform module catalog entry. */
export function resolvePlatformModuleComponent(
  moduleCode: string,
  screenId?: string | null,
  componentFromDb?: string | null
): string {
  const fromDb = componentFromDb?.trim();
  const code = moduleCode.trim();
  const screen = screenId?.trim();
  const mapped =
    (code && PLATFORM_MODULE_COMPONENTS[code]) ||
    (screen && PLATFORM_MODULE_COMPONENTS[screen.replace(/-/g, '_')]) ||
    undefined;

  // Older catalog rows were populated with the generic placeholder before
  // dedicated screens existed. Let the maintained module map upgrade those
  // rows while preserving any explicitly configured custom component.
  if (fromDb && fromDb !== 'GenericSchoolModule') return fromDb;
  if (mapped) return mapped;
  if (fromDb) return fromDb;

  return 'GenericSchoolModule';
}
